
<script lang="ts" setup>
import type { IProps } from './solutions-UiBoxSimple.types'

defineProps<IProps>()
</script>

<template>
  <article class="box">
    <p>
      {{ box.text }}
    </p>
  </article>
</template>

<style lang="scss" scoped>
  .box {
    padding: 2.4rem 2rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: center;
    background-color: $white;
    border: 1px solid $gray-200;
    border-radius: 1.6rem;

    @include atM {
      padding: 3.2rem 4.4rem;
      font-size: 2rem;
      line-height: 2.8rem;
    }
  }
</style>
